import React, { ReactNode, Children, Suspense } from "react";

type Props<T> = {
    render: (item: T, index: number) => ReactNode;
    of: T[];
    isActive?: boolean;
};

function Each<T>({ render, of, isActive }: Props<T>) {
    if (isActive) return null;

    return (
        <Suspense fallback={<div>Loading...</div>}>
            {Children.toArray(of.map((item, index) => render(item, index)))}
        </Suspense>
    );
}
export default Each;
